import getConfig from "next/config";
import { useTranslation } from "@lib/i18n";

import { useRoutingUtils } from "@hooks/useRoutingUtils";
import { useBrandIdSettingsSelector } from "@redux/reducers/appConfig";

const { publicRuntimeConfig } = getConfig();

const { ROOT_URL_PREFIX } = publicRuntimeConfig;

export const useGetBrandIdRedirect = () => {
  const { i18n } = useTranslation();
  const { frontendUrl } = useBrandIdSettingsSelector();
  const routingUtils = useRoutingUtils();

  return (
    route,
    params = null,
    language = i18n.language,
    addFrontendUrl = true
  ) => {
    return (
      (addFrontendUrl ? frontendUrl : "") +
      ROOT_URL_PREFIX +
      routingUtils.getLocalizedPathname(route, params, language)
    );
  };
};
